"use client";

import { useState } from "react";

const faqs = [
  {
    question: "Is there a free trial available for CarerLab?",
    answer: "Yes, CarerLab offers a free trial for new users.",
  },
  {
    question: "Is CarerLab a cloud-based software?",
    answer: "Yes, CarerLab is a cloud-based solution, accessible from any device with internet.",
  },
  {
    question: "Do I need any specification to run this software?",
    answer: "No specific requirements. CarerLab is designed to be user-friendly and compatible with most devices.",
  },
  {
    question: "Can I customize the reports sent through CarerLab?",
    answer: "Yes, CarerLab allows for customizations in report format and branding.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleIndex = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="p-8 max-w-[950px] mx-auto mb-10 text-black">
      <h2 className="text-center text-2xl md:text-3xl font-bold mb-8">
        Frequently Asked Questions
      </h2>

      <div className="border border-gray-300 rounded-md divide-y divide-gray-300">
        {faqs.map((faq, index) => (
          <div key={index} className="relative">
            <button
              onClick={() => toggleIndex(index)}
              className={`w-full text-left flex justify-between items-center p-4 font-normal text-lg ${
                openIndex === index ? "bg-gray-500" : ""
              }`}
            >
              <span className="text-4xl mr-2 font-normal">+</span>
              {faq.question.replace("+", "")}
              <span className="ml-2 transform transition-transform duration-200">
                {openIndex === index ? "-" : ""}
              </span>
            </button>
            {openIndex === index && (
              <div className="p-4 text-gray-600">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
